export enum PermissionRule {
  AcceptForEndUser = "accept_for_end_user",
  AddYourselfAsOwner = "add_yourself_as_owner",
  AIGeneratedDescription = "ai_generated_description",
  AuditAdmin = "audit_admin",
  AuditApprover = "audit_approver",
  AuditLog = "audit_log",
  AuditResourcer = "audit_resourcer",
  BookingAccess = "booking_module_access",
  BookingAdmin = "booking_admin",
  BookingApprover = "booking_approver",
  BookingResourcer = "booking_resourcer",
  BulkBookingsOperations = "bulk_bookings_operations",
  BulkManageRoles = "bulk_manage_roles",
  ChangeMarketplaceRequirements = "marketplace_requirements_visibility",
  ContactForm = "contact_form",
  CreateEngagementBookings = "create_engagement_bookings",
  DeletePlaceholderProfiles = "delete_placeholder_profiles",
  Documentation = "documentation",
  DynamicInsights = "dynamic_insights",
  EngagementEconomicsCreateScenarios = "engagement_economics_create_scenarios",
  EngagementEconomicsManage = "engagement_economics_manage",
  ExportDocuments = "export_documents",
  FillNamedResource = "fill_named_resource",
  FilterByWorkforceMember = "filter_by_workforce_member",
  ImportExportRoles = "import_export_roles",
  IntegrationUser = "integration_user",
  KPIsAccess = "kpis_access",
  KPIsApprover = "kpis_approver",
  KPIsRequestApproval = "kpis_request_approval",
  ManageOverbookings = "manage_overbookings",
  PermissionsGroupsManagement = "permissions_groups_management",
  ProfessionalProfileEdit = "professional_profile_edit",
  ProfileList = "profile_list",
  ProjectManager = "project_manager",
  ProPilot = "pro_pilot",
  GridView = "grid_view",
  ReassignBookingsMatches = "reassign_bookings_matches",
  ReassignBookingsAllResources = "reassign_bookings_all_resources",
  Reporter = "reporter",
  Resourcer = "resourcer",
  RestrictActivityParticipantsVisibility = "restrict_activity_participants_visibility",
  RoleForward = "roll_forward",
  RoleRemoval = "role_removal",
  SeniorPartner = "senior_partner",
  ShortlistWithoutOwnership = "shortlist_without_ownership",
  ManageShortlist = "manage_shortlist",
  ManagePublicActivityBookings = "manage_public_activity_bookings",
  TalentMarketplace = "talent_marketplace",
  TaskList = "task_list",
  TranslateCVExports = "translate_cv_exports",
  TranslateCustomValues = "translate_custom_values",
  UsageAnalytics = "usage_analytics",
  UserManager = "user_manager",
  UsersImport = "users_import",
  WallPlannerAccess = "wall_planner_access",
  WorkflowTransfer = "workflow_transfer"
}
